import { render, staticRenderFns } from "./te-IN.vue?vue&type=template&id=e87bd520&"
import script from "./te-IN.vue?vue&type=script&lang=js&"
export * from "./te-IN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e87bd520')) {
      api.createRecord('e87bd520', component.options)
    } else {
      api.reload('e87bd520', component.options)
    }
    module.hot.accept("./te-IN.vue?vue&type=template&id=e87bd520&", function () {
      api.rerender('e87bd520', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/Languages/te-IN.vue"
export default component.exports